import router from "@/router";
import {convertDate} from "@/globalFunctions";
import i18n from "@/lang";
import {License} from "@/data/classes/license";
let license = new License();

export const tabs : any[] = [
    {
        key: "customer",
        label: "license-form.tabs.customer",
        type: "single",
        sections: [
            {
                inputs: [
                    {
                        label: 'license-form.license-owner.type',
                        name: 'input_license_owner_type',
                        type: 'select',
                        options: [
                            {
                                key: "business",
                                value: "business",
                                label: 'license-form.license-owner.type-business'
                            },{
                                key: "private",
                                value: "private",
                                label: 'license-form.license-owner.type-private'
                            }
                        ],
                        required: false,
                        rules: '',
                        path: "LicenseOwner.Type",
                        size: 100
                    }
                ]
            },
            {
                title: 'license-form.company.title',
                inputs: [
                    {
                        label: 'license-form.company.name',
                        name: 'input_license_general_company_name',
                        type: 'text',
                        required: true,
                        rules: '',
                        path: "Billing.Name",
                        size: 50
                    },
                    {
                        label: 'license-form.company.tax-number',
                        name: 'input_license_general_company_tax_number',
                        type: 'text',
                        required: false,
                        rules: '',
                        path: "Billing.TaxCode",
                        size: 50
                    },
                    {
                        label: 'license-form.company.street',
                        name: 'input_license_general_company_street',
                        type: 'text',
                        required: false,
                        rules: '',
                        path: "Billing.Address.Line1",
                        size: 45
                    },
                    {
                        label: 'license-form.company.housenumber',
                        name: 'input_license_general_company_housenumber',
                        type: 'text',
                        required: false,
                        rules: '',
                        path: "Billing.Address.Line2",
                        size: 25
                    },
                    {
                        label: 'license-form.company.postal-code',
                        name: 'input_license_general_company_postalcode',
                        type: 'text',
                        required: false,
                        rules: '',
                        path: "Billing.Address.PostalCode",
                        size: 30
                    },
                    {
                        label: 'license-form.company.city',
                        name: 'input_license_general_company_city',
                        type: 'text',
                        required: false,
                        rules: '',
                        path: "Billing.Address.City",
                        size: 50
                    },
                    {
                        label: 'license-form.company.country',
                        name: 'input_license_general_company_country',
                        type: 'text',
                        required: false,
                        rules: '',
                        path: "Billing.Address.Country",
                        size: 50
                    },
                    {
                        label: 'license-form.company.phone',
                        name: 'input_license_general_company_phone',
                        type: 'text',
                        required: false,
                        rules: '',
                        path: "Billing.Phone",
                        size: 50
                    },
                    {
                        label: 'license-form.company.email',
                        name: 'input_license_general_company_email',
                        type: 'text',
                        required: false,
                        rules: 'email',
                        path: "Billing.Email",
                        size: 50
                    },
                ]
            },
            {
                title: 'license-form.license-owner.title',
                inputs: [
                    {
                        label: 'license-form.license-owner.sex',
                        name: 'input_license_owner_sex',
                        type: 'select',
                        options: [
                            {
                                key: "male",
                                value: "male",
                                label: 'license-form.contact.sex-male'
                            },{
                                key: "female",
                                value: "female",
                                label: 'license-form.contact.sex-female'
                            },{
                                key: "other",
                                value: "other",
                                label: 'license-form.contact.sex-other'
                            }
                        ],
                        required: false,
                        rules: '',
                        path: "LicenseOwner.Sex",
                        size: 15,
                        bindings: [{
                            path: "Contact.Sex",
                            force: false
                        }]
                    },
                    {
                        label: 'license-form.license-owner.initials',
                        name: 'input_license_owner_initials',
                        type: 'text',
                        required: false,
                        rules: '',
                        path: "LicenseOwner.Initials",
                        size: 15,
                        bindings: [{
                            path: "Contact.Initials",
                            force: false
                        }]
                    },
                    {
                        label: 'license-form.license-owner.first-name',
                        name: 'input_license_owner_first_name',
                        type: 'text',
                        required: false,
                        rules: '',
                        path: "LicenseOwner.FirstName",
                        size: 25,
                        bindings: [{
                            path: "Contact.FirstName",
                            force: false
                        }]
                    },
                    {
                        label: 'license-form.license-owner.infix',
                        name: 'input_license_owner_infix',
                        type: 'text',
                        required: false,
                        rules: '',
                        path: "LicenseOwner.Infix",
                        size: 20,
                        bindings: [{
                            path: "Contact.Infix",
                            force: false
                        }]
                    },
                    {
                        label: 'license-form.license-owner.last-name',
                        name: 'input_license_owner_last_name',
                        type: 'text',
                        required: false,
                        rules: '',
                        path: "LicenseOwner.LastName",
                        size: 25,
                        bindings: [{
                            path: "Contact.LastName",
                            force: false
                        }]
                    },
                    {
                        label: 'license-form.license-owner.phone',
                        name: 'input_license_owner_phone',
                        type: 'text',
                        required: false,
                        rules: '',
                        path: "LicenseOwner.Phone",
                        size: 50,
                        bindings: [{
                            path: "Contact.Phone",
                            force: false
                        }]
                    },
                    {
                        label: 'license-form.license-owner.email',
                        name: 'input_license_owner_email',
                        type: 'text',
                        required: true,
                        rules: 'email',
                        path: "LicenseOwner.Email",
                        size: 50,
                        bindings: [{
                            path: "Contact.Email",
                            force: false
                        }]
                    },
                    {
                        label: 'license-form.license-owner.role',
                        name: 'input_license_owner_role',
                        type: 'text',
                        required: false,
                        rules: '',
                        path: "LicenseOwner.Role",
                        size: 50,
                        bindings: [{
                            path: "Contact.Role",
                            force: false
                        }]
                    },
                    {
                        label: 'license-form.license-owner.locale',
                        name: 'input_license_owner_locale',
                        type: 'language',
                        required: false,
                        rules: '',
                        path: "LicenseOwner.DefaultLocale",
                        size: 50,
                        bindings: [{
                            path: "Contact.DefaultLocale",
                            force: false
                        }]
                    },
                ]
            }
        ]
    },
    {
        key: "billing",
        label: "license-form.tabs.billing",
        type: "single",
        sections: [
            {
                title: 'license-form.billing.contact',
                inputs: [
                    {
                        label: 'license-form.contact.sex',
                        name: 'input_contact_sex',
                        type: 'select',
                        options: [
                            {
                                key: "male",
                                value: "male",
                                label: 'license-form.contact.sex-male'
                            },{
                                key: "female",
                                value: "female",
                                label: 'license-form.contact.sex-female'
                            },{
                                key: "other",
                                value: "other",
                                label: 'license-form.contact.sex-other'
                            }
                        ],
                        required: false,
                        rules: '',
                        path: "Contact.Sex",
                        size: 15
                    },
                    {
                        label: 'license-form.contact.initials',
                        name: 'input_license_general_contact_initials',
                        type: 'text',
                        required: false,
                        rules: '',
                        path: "Contact.Initials",
                        size: 15
                    },
                    {
                        label: 'license-form.contact.first-name',
                        name: 'input_license_general_contact_first_name',
                        type: 'text',
                        required: false,
                        rules: '',
                        path: "Contact.FirstName",
                        size: 25
                    },
                    {
                        label: 'license-form.contact.infix',
                        name: 'input_license_general_contact_infix',
                        type: 'text',
                        required: false,
                        rules: '',
                        path: "Contact.Infix",
                        size: 20
                    },
                    {
                        label: 'license-form.contact.last-name',
                        name: 'input_license_general_contact_last_name',
                        type: 'text',
                        required: false,
                        rules: '',
                        path: "Contact.LastName",
                        size: 25
                    },
                    {
                        label: 'license-form.contact.phone',
                        name: 'input_license_general_contact_phone',
                        type: 'text',
                        required: false,
                        rules: '',
                        path: "Contact.Phone",
                        size: 50
                    },
                    {
                        label: 'license-form.contact.email',
                        name: 'input_license_general_contact_email',
                        type: 'text',
                        required: true,
                        rules: 'email',
                        path: "Contact.Email",
                        size: 50
                    },
                    {
                        label: 'license-form.contact.role',
                        name: 'input_license_general_contact_role',
                        type: 'text',
                        required: false,
                        rules: '',
                        path: "Contact.Role",
                        size: 50
                    },
                    {
                        label: 'license-form.contact.locale',
                        name: 'input_license_general_contact_locale',
                        type: 'language',
                        required: false,
                        rules: '',
                        path: "Contact.DefaultLocale",
                        size: 50
                    },
                ]
            },
            {
                title: 'license-form.billing.invoice',
                inputs: [
                    {
                        label: 'license-form.billing.invoice',
                        name: 'input_billing_invoice',
                        type: 'text',
                        required: false,
                        rules: '',
                        path: "Billing.Invoice",
                        size: 50
                    },
                    {
                        label: 'license-form.billing.purchase-order-number',
                        name: 'input_billing_purchase_order_number',
                        type: 'text',
                        required: false,
                        rules: '',
                        path: "Billing.PurchaseOrderNumber",
                        size: 50
                    },
                    {
                        label: 'license-form.billing.payment-method',
                        name: 'input_billing_payment_method',
                        type: 'select',
                        options: [{
                            key: "invoice",
                            label: "license-form.billing.payment-method-invoice",
                            value: "invoice"
                        },{
                            key: "automatic-collection",
                            label: "license-form.billing.payment-method-automatic-collection",
                            value: "automatic-collection"
                        },{
                            key: "ideal",
                            label: "license-form.billing.payment-method-ideal",
                            value: "ideal"
                        },{
                            key: "paypal",
                            label: "license-form.billing.payment-method-paypal",
                            value: "paypal"
                        },{
                            key: "creditcard",
                            label: "license-form.billing.payment-method-creditcard",
                            value: "creditcard"
                        }],
                        required: false,
                        rules: '',
                        path: "Billing.PaymentMethod",
                        size: 100
                    }
                ]
            }
        ]
    },
    {
        key: "license",
        label: "license-form.tabs.license",
        type: "single",
        sections: [
            {
                title: 'license-form.license.license',
                inputs: [
                    {
                        label: 'license-form.license.platform',
                        name: 'input_license_platform',
                        type: 'select',
                        options: [{
                            key: "veewar",
                            label: "VEEWAR",
                            value: "veewar"
                        },{
                            key: "veeew",
                            label: "VEEEW",
                            value: "veeew"
                        }],
                        required: true,
                        rules: '',
                        path: "PlatformId",
                        disabled: false,
                        size: 100
                    },
                    {
                        label: 'license-form.license.license-name',
                        name: 'input_license_name',
                        type: 'text',
                        required: true,
                        rules: '',
                        path: "LicenseName",
                        size: 50
                    },
                    {
                        label: 'license-form.license.license-id',
                        name: 'input_license_id',
                        type: 'text',
                        required: true,
                        rules: '',
                        path: "Id",
                        disabled: true,
                        size: 50
                    },
                    {
                        label: 'license-form.license.license-type',
                        name: 'input_license_type',
                        type: 'select',
                        options:[{
                            key:"monthly",
                            value:"monthly",
                            label:"license-form.license.license-type-monthly"
                        },{
                            key:"one-time",
                            value:"one-time",
                            label:"license-form.license.license-type-one-time"
                        },{
                            key:"read-only",
                            value:"read-only",
                            label:"license-form.license.license-type-read-only"
                        },{
                            key:"trial",
                            value:"trial",
                            label:"license-form.license.license-type-trial"
                        }],
                        required: true,
                        rules: '',
                        path: "Subscription.Type",
                        disabled: false,
                        size: 50,
                        bindings: [{
                            path: "Scans.Type",
                            force: true,
                            processor: (x: string) => {
                                return ["one-time", "trial"].indexOf(x) >= 0 ? "one-time" : "monthly";
                            }
                        },{
                            path: "Subscription.PaymentType",
                            force: true,
                            processor: (x: string) => {
                                return ["one-time", "trial"].indexOf(x) >= 0 ? "one-time" : "monthly";
                            }
                        }]
                    },
                    {
                        label: 'license-form.license.local-database',
                        name: 'input_license_local_database',
                        type: 'select',
                        options:[{
                            key:"true",
                            value: true,
                            label:"license-form.license.local-database-true"
                        },{
                            key:"false",
                            value: false,
                            label:"license-form.license.local-database-false"
                        }],
                        required: true,
                        rules: '',
                        path: "Subscription.LocalDatabase",
                        disabled: false,
                        size: 50
                    }
                ]
            },
            {
                title: 'license-form.license.period',
                inputs: [
                    {
                        label: 'license-form.license.date-range',
                        name: 'input_license_date_range',
                        type: 'daterange',
                        required: true,
                        decode: (dates: unknown[]) => {
                            if (dates){
                                return [convertDate(dates[0])?.toISOString().split("T")[0],convertDate(dates[1])?.toISOString().split("T")[0]];
                            } else {
                                return [new Date().toISOString().split("T")[0], new Date(new Date().getFullYear()+1, new Date().getMonth(), new Date().getDate()).toISOString().split("T")[0]]
                            }
                        },
                        encode: (dates: string[]) => {
                            return [new Date(dates[0]),new Date(dates[1])];
                        },
                        disableDate: (time: Date) => {
                            return time.getTime() > Date.now();
                        },
                        dateShortcuts: [{
                            text: i18n.t('element-ui.date-picker.ranges.half-year'),
                            onClick(picker: any) {
                                const end = new Date();
                                const start = new Date();
                                end.setTime(end.getTime() + 3600 * 1000 * 24 * 182);
                                picker.$emit('pick', [start, end]);
                            }
                        },{
                            text: i18n.t('element-ui.date-picker.ranges.year'),
                            onClick(picker: any) {
                                const end = new Date();
                                const start = new Date();
                                end.setTime(end.getTime() + 3600 * 1000 * 24 * 365);
                                picker.$emit('pick', [start, end]);
                            }
                        },{
                            text: i18n.t('element-ui.date-picker.ranges.two-year'),
                            onClick(picker: any) {
                                const end = new Date();
                                const start = new Date();
                                end.setTime(end.getTime() + 3600 * 1000 * 24 * 365 * 2);
                                picker.$emit('pick', [start, end]);
                            }
                        },{
                            text: i18n.t('element-ui.date-picker.ranges.five-year'),
                            onClick(picker: any) {
                                const end = new Date();
                                const start = new Date();
                                end.setTime(end.getTime() + 3600 * 1000 * 24 * 365 * 5);
                                picker.$emit('pick', [start, end]);
                            }
                        }],
                        rules: '',
                        path: "Subscription.DateRange",
                        disabled: false,
                        size: 100,
                        bindings: [{
                            path: "Subscription.StartDate",
                            force: true,
                            processor: (value: Date[]) => {
                                return value[0]
                            }
                        },{
                            path: "Subscription.EndDate",
                            force: true,
                            processor: (value: Date[]) => {
                                return value[1]
                            }
                        }],
                    }
                ]
            },
            {
                title: 'license-form.license.scans',
                inputs: [
                    {
                        label: 'license-form.license.scan-type',
                        name: 'input_license_scan_type',
                        type: 'select',
                        options:[{
                            key:"monthly",
                            value:"monthly",
                            label:"license-form.license.scan-type-monthly"
                        },{
                            key:"one-time",
                            value:"one-time",
                            label:"license-form.license.scan-type-one-time"
                        }],
                        required: true,
                        rules: '',
                        path: "Scans.Type",
                        disabled: false,
                        size: 50
                    },
                    {
                        label: 'license-form.license.maximum-scans-per-month',
                        name: 'input_license_maximum_per_month',
                        type: 'number',
                        required: true,
                        rules: '',
                        path: "Scans.GeneralMaximum",
                        size: 50,
                        condition: (item: License) : boolean => {
                            return item?.Scans?.Type === "monthly";
                        },
                        rootGetter: "admin/license/getRootPath",
                        rootPath: "active"
                    },
                    {
                        label: 'license-form.license.maximum-scans',
                        name: 'input_license_maximum',
                        type: 'number',
                        required: true,
                        rules: '',
                        path: "Scans.GeneralMaximum",
                        size: 50,
                        condition: (item: License) : boolean => {
                            return item?.Scans?.Type !== "monthly";
                        },
                        rootGetter: "admin/license/getRootPath",
                        rootPath: "active"
                    },
                    {
                        label: 'license-form.license.allow-limit-exceed',
                        name: 'input_license_allow_limit_exceed',
                        type: 'select',
                        options:[{
                            key:"allow",
                            value:true,
                            label:"license-form.license.do-allow-limit-exceed"
                        },{
                            key:"offline",
                            value:false,
                            label:"license-form.license.take-markers-offline"
                        }],
                        required: true,
                        rules: '',
                        path: "Scans.AllowLimitExceed",
                        disabled: false,
                        size: 50
                    },
                    {
                        label: 'license-form.license.cost-per-extra-scan',
                        name: 'input_license_cost_per_extra_scan',
                        type: 'number',
                        required: false,
                        rules: '',
                        path: "Subscription.CostPerExtraScan",
                        disabled: false,
                        size: 50,
                        condition: (item: License) : boolean => {
                            return item?.Scans?.AllowLimitExceed;
                        },
                        rootGetter: "admin/license/getRootPath",
                        rootPath: "active"
                    },
                    {
                        label: 'license-form.license.restrict-limit-exceed',
                        name: 'input_license_restrict_limit_exceed',
                        type: 'select',
                        options:[{
                            key:"allow",
                            value: "scans",
                            label:"license-form.license.restrict-on-scans"
                        },{
                            key:"offline",
                            value: "none",
                            label:"license-form.license.do-not-restrict"
                        }],
                        required: false,
                        rules: '',
                        path: "Subscription.RestrictOn",
                        disabled: false,
                        size: 50,
                        bindings: [{
                            path: "Scans.Restriction",
                            force: true
                        }],
                        condition: (item: License) : boolean => {
                            return item?.Scans?.AllowLimitExceed;
                        }
                    },
                    {
                        label: 'license-form.license.maximum-scans-above-limit',
                        name: 'input_license_maximum_scans_above_limit',
                        type: 'number',
                        required: false,
                        rules: '',
                        path: "Subscription.MaximumScansAboveLimit",
                        disabled: false,
                        size: 50,
                        condition: (item: License) : boolean => {
                            return item?.Subscription?.RestrictOn === 'scans' && item?.Scans?.AllowLimitExceed;
                        }
                    }
                ]
            },
            {
                title: 'license-form.license.pricing',
                inputs: [
                    {
                        label: 'license-form.license.payment-type',
                        name: 'input_license_payment_type',
                        type: 'select',
                        options:[{
                            key:"monthly",
                            value:"monthly",
                            label:"license-form.license.payment-type-monthly"
                        },{
                            key:"one-time",
                            value:"one-time",
                            label:"license-form.license.payment-type-one-time"
                        }],
                        required: true,
                        rules: '',
                        path: "Subscription.PaymentType",
                        disabled: false,
                        size: 50
                    },
                    {
                        label: 'license-form.license.price-per-month',
                        name: 'input_license_price_per_month',
                        type: 'number',
                        required: true,
                        rules: '',
                        path: "Subscription.MonthlyFee",
                        size: 50,
                        condition: (item: License) : boolean => {
                            return item?.Subscription?.PaymentType === "monthly";
                        },
                        rootGetter: "admin/license/getRootPath",
                        rootPath: "active"
                    },
                    {
                        label: 'license-form.license.price',
                        name: 'input_license_price',
                        type: 'number',
                        required: true,
                        rules: '',
                        path: "Subscription.OneTimeFee",
                        size: 50,
                        condition: (item: License) : boolean => {
                            return item?.Subscription?.PaymentType === "one-time";
                        },
                        rootGetter: "admin/license/getRootPath",
                        rootPath: "active"
                    }
                ]
            },
            {
                title: 'license-form.license.settings',
                inputs: [
                    {
                        label: 'license-form.license.apps',
                        name: 'input_license_apps',
                        type: 'select',
                        options:[{
                            key:"veewar",
                            value:"veewar",
                            label:"VEEWAR"
                        },{
                            key:"veeew",
                            value:"veeew",
                            label:"VEEEW"
                        }],
                        multiple: true,
                        required: true,
                        rules: '',
                        path: "Apps",
                        disabled: false,
                        size: 100
                    },
                    {
                        label: 'license-form.license.seats',
                        name: 'input_license_seats',
                        type: 'number',
                        required: true,
                        rules: '',
                        path: "Subscription.Seats",
                        size: 50,
                        condition: (item: License) : boolean => {
                            return item?.Subscription?.Type !== "read-only";
                        },
                        rootGetter: "admin/license/getRootPath",
                        rootPath: "active"
                    },
                    {
                        label: 'license-form.license.viewers',
                        name: 'input_license_viewers',
                        type: 'number',
                        required: true,
                        rules: '',
                        path: "Subscription.Viewers",
                        size: 50,
                        condition: (item: License) : boolean => {
                            return item?.Subscription?.Type !== "read-only";
                        },
                        rootGetter: "admin/license/getRootPath",
                        rootPath: "active"
                    }
                ]
            }
        ]
    }
]


export const getData = async () => {
    if (router.currentRoute.params.licenseId !== "new"){
        await license.get(router.currentRoute.params.licenseId);
    } else {
        license = new License();
    }

    return license.toJSON();
}


export const onSubmit = async (formValues: any) => {
    // Set values
    license.set(formValues);

    // Update license
    return license.update();
}
